import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
import Spinner from "../components/Spinner/Spinner";
import { useRouter } from "next/router";

const UserRegistrationForm = dynamic(() =>
  import("../components/SignIn/UserSignIn"),
  {
    ssr: false,
    loading: () => <Spinner />,
  }
);


const signin = () => {
  const router = useRouter();

  // if(localStorage.getItem('kcTokenSaved')){
  //   router.push('/');
  // }

  return (
    <Layout>
      <UserRegistrationForm />
    </Layout>
  );
};

export default signin;
